import { useTranslation } from 'react-i18next';
import { useKeyboardShortcuts } from 'hooks/useKeyboardShortcuts/useKeyboardShortcuts';

export const useGeoLocationCommandPaletteAction = (
  updateUserPosition: () => void,
): void => {
  const { t } = useTranslation();
  useKeyboardShortcuts(
    [
      {
        category: 'mapTools',
        description: t('keyboardShortcuts.nearMe'),
        keys: 'g l',
        handler: updateUserPosition,
      },
    ],
    [updateUserPosition],
  );
};
